<template>
  <div class="faq-area">
    <div class="faq-box">
      <div class="text-area">
        <h1>
          {{ $t('faq.header') }}
        </h1>
        <p class="desc">
          {{ $t('faq.description') }}
        </p>
      </div>
      <div class="image-area">
        <div class="picture">
          <picture>
            <source srcset="/img/new/faq.webp" type="image/webp">
            <nuxt-img
              fit="inside"
              width="812"
              sizes="sm:300px md:400px lg:500px xl:500px xxl:600px"
              src="/img/new/faq.png"
              alt="Question answers on Defi Pool Finance about blockchain interactions"
              title="Defi Pool FAQ"
            />
          </picture>
        </div>
      </div>
      <div class="cyan-cloud">
        <CloudCyanVotingRight />
      </div>
      <div class="cyan-cloud2">
        <CloudCyanVotingLeft />
      </div>
    </div>

    <div class="questions">
      <div class="question-area">
        <div :class="{'question': true, 'active': currentTab === 0}" @click="changeTab(0)">
          <div class="icon">
            <Flamingo />
          </div>
          <div class="h6">
            {{ $t('faq.what_is_defipool') }}
          </div>
          <div class="chevron">
            <ChevronDown />
          </div>
        </div>
        <div ref="accordion0" class="answer">
          <p>
            {{ $t('faq.what_is_defipool_p1') }}&nbsp;
            <nuxt-link :to="localePath('/docs#roadmap')">
              {{ $t('faq.here') }}
            </nuxt-link>.
          </p>
        </div>
      </div>
      <div class="question-area">
        <div :class="{'question': true, 'active': currentTab === 1}" @click="changeTab(1)">
          <div class="icon">
            <Security />
          </div>
          <div class="h6">
            {{ $t('faq.how_to_unstake') }}
          </div>
          <div class="chevron">
            <ChevronDown />
          </div>
        </div>
        <div ref="accordion1" class="answer">
          <p>
            {{ $t('faq.how_to_unstake_p1') }}
          </p>
          <p>
            {{ $t('faq.how_to_unstake_p2') }}
          </p>
        </div>
      </div>
      <div class="question-area">
        <div :class="{'question': true, 'active': currentTab === 2}" @click="changeTab(2)">
          <div class="icon">
            <Puzzle />
          </div>
          <div class="h6">
            {{ $t('faq.provide_liquidity') }}
          </div>
          <div class="chevron">
            <ChevronDown />
          </div>
        </div>
        <div ref="accordion2" class="answer">
          <p>
            {{ $t('faq.provide_liquidity_p1') }}
          </p>
        </div>
      </div>
      <div class="question-area">
        <div :class="{'question': true, 'active': currentTab === 3}" @click="changeTab(3)">
          <div class="icon">
            <CryptoCoin />
          </div>
          <div class="h6">
            {{ $t('faq.why_my_transaction') }}
          </div>
          <div class="chevron">
            <ChevronDown />
          </div>
        </div>
        <div ref="accordion3" class="answer">
          <p>
            {{ $t('faq.why_my_transaction_p1') }}
          </p>
          <p>
            {{ $t('faq.why_my_transaction_p2') }}
          </p>
          <p>
            {{ $t('faq.why_my_transaction_p3') }}
          </p>
        </div>
      </div>
      <div class="question-area">
        <div :class="{'question': true, 'active': currentTab === 4}" @click="changeTab(4)">
          <div class="icon">
            <CoinHold />
          </div>
          <div class="h6">
            {{ $t('faq.receive_airdrops') }}
          </div>
          <div class="chevron">
            <ChevronDown />
          </div>
        </div>
        <div ref="accordion4" class="answer">
          <p>
            {{ $t('faq.receive_airdrops_p1') }}
          </p>
        </div>
      </div>
    </div>
    <div class="answers">
      <div ref="tab0" :class="{'answer': true, 'active': currentTab === 0}">
        <p class="no-flex">
          {{ $t('faq.what_is_defipool_p1') }}&nbsp;<nuxt-link :to="localePath('/roadmap')">{{ $t('faq.here') }}</nuxt-link>.
        </p>
      </div>
      <div ref="tab1" :class="{'answer': true, 'active': currentTab === 1}">
        <p>
          {{ $t('faq.how_to_unstake_p1') }}
        </p>
        <p>
          {{ $t('faq.how_to_unstake_p2') }}
        </p>
      </div>
      <div ref="tab2" :class="{'answer': true, 'active': currentTab === 2}">
        <p>
          {{ $t('faq.provide_liquidity_p1') }}
        </p>
      </div>
      <div ref="tab3" :class="{'answer': true, 'active': currentTab === 3}">
        <p>
          {{ $t('faq.why_my_transaction_p1') }}
        </p>
        <p>
          {{ $t('faq.why_my_transaction_p2') }}
        </p>
        <p>
          {{ $t('faq.why_my_transaction_p3') }}
        </p>
      </div>
      <div ref="tab4" :class="{'answer': true, 'active': currentTab === 4}">
        <p>
          {{ $t('faq.receive_airdrops_p1') }}
        </p>
      </div>
    </div>
    <div class="feedback-area">
      <div class="image-area">
        <picture>
          <source srcset="/img/new/lifeguard.webp" type="image/webp">
          <nuxt-img
            fit="inside"
            width="928"
            sizes="sm:275px md:300px lg:400px xl:500px xxl:600px"
            src="/img/new/lifeguard.png"
            alt="Blockchain qustions answered on Defi Pool Finance"
            title="FAQ answering form"
          />
        </picture>
        <p>
          {{ $t('faq.for_more_info') }}&nbsp;
          <nuxt-link :to="localePath('/docs')">
            {{ $t('faq.pool_rules') }}
          </nuxt-link>
        </p>
      </div>
      <div class="form-area">
        <div class="h4">
          {{ $t('faq.lifeguard') }}
        </div>
        <p class="desc">
          {{ $t('faq.lifeguard_desc') }}
        </p>
        <div class="form">
          <div class="input mr-3">
            <input v-model="feedback.name" type="text" :placeholder="$t('faq.name') + ' *'" @input="validateName">
            <div ref="nameError" :class="{'error-message': true, 'active': errors.name.length > 0}" :tooltip="errors.name">
              <ErrorSign />
            </div>
          </div>
          <div class="input mr-3">
            <input v-model="feedback.email" type="email" :placeholder="$t('faq.email') + ' *'" @change="validateEmail">
            <div ref="emailError" :class="{'error-message': true, 'active': errors.email.length > 0}" :tooltip="errors.email">
              <ErrorSign />
            </div>
          </div>
          <div class="input">
            <input v-model="feedback.telegram" type="text" :placeholder="$t('faq.telegram')" @input="validateNickname">
            <div ref="telegramError" :class="{'error-message': true, 'active': errors.telegram.length > 0}" :tooltip="errors.telegram">
              <ErrorSign />
            </div>
          </div>
          <div class="input w-100">
            <textarea v-model="feedback.message" type="text" :placeholder="$t('faq.message') + ' *'" rows="3" @input="validateMessage"></textarea>
            <div ref="messageError" :class="{'error-message': true, 'active': errors.message.length > 0}" :tooltip="errors.message">
              <ErrorSign />
            </div>
          </div>
        </div>
        <div class="buttons-area">
          <button type="submit" class="btn cyan" @click.prevent="sendFeedback">
            <span v-if="!feedbackLoading">
              {{ $t('faq.send_message') }}
            </span>
            <span v-else>
              <Loading />
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  hydrateWhenIdle,
  hydrateWhenVisible
} from 'vue-lazy-hydration'

export default {
  name: 'FaqPage',
  components: {
    ChevronDown: hydrateWhenIdle(() => import('~/components/svg/new/ChevronDown')),
    CloudCyanVotingLeft: hydrateWhenIdle(() => import('~/components/svg/new/clouds/CloudCyanVotingLeft')),
    CloudCyanVotingRight: hydrateWhenIdle(() => import('~/components/svg/new/clouds/CloudCyanVotingRight')),
    CoinHold: hydrateWhenIdle(() => import('~/components/svg/new/CoinHold')),
    CryptoCoin: hydrateWhenIdle(() => import('~/components/svg/new/CryptoCoin')),
    ErrorSign: hydrateWhenVisible(() => import('~/components/svg/new/ErrorSign')),
    Flamingo: hydrateWhenIdle(() => import('~/components/svg/new/Flamingo')),
    Loading: hydrateWhenVisible(() => import('~/components/svg/new/Loading')),
    Puzzle: hydrateWhenIdle(() => import('~/components/svg/new/Puzzle')),
    Security: hydrateWhenIdle(() => import('~/components/svg/new/Security'))
  },
  layout: 'new',
  data() {
    return {
      currentTab: 0,
      countTabs: 5,
      feedback: {
        name: '',
        email: '',
        telegram: '',
        message: ''
      },
      errors: {
        name: '',
        email: '',
        telegram: '',
        message: ''
      },
      feedbackLoading: false,
      timeouts: {
        name: null,
        email: null,
        telegram: null,
        message: null
      },
      timeoutTime: 500
    }
  },
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    }
  },
  mounted() {
    if (this.$refs['tab' + this.currentTab] !== undefined) {
      this.$refs['tab' + this.currentTab].style.maxHeight = this.$refs['tab' + this.currentTab].scrollHeight + 'px'
    }
    if (this.$refs['accordion' + this.currentTab] !== undefined) {
      this.$refs['accordion' + this.currentTab].style.maxHeight = this.$refs['accordion' + this.currentTab].scrollHeight + 'px'
    }
  },
  methods: {
    changeTab(newTab) {
      if (parseInt(this.currentTab, 10) !== parseInt(newTab, 10)) {
        this.currentTab = parseInt(newTab, 10)
        for (let ind = 0; ind < this.countTabs; ++ind) {
          if (this.$refs['tab' + ind] !== undefined) {
            this.$refs['tab' + ind].style.maxHeight = ind !== this.currentTab ? null : this.$refs['tab' + ind].scrollHeight + 'px'
          }
          if (this.$refs['accordion' + ind] !== undefined) {
            this.$refs['accordion' + ind].style.maxHeight = ind !== this.currentTab ? null : this.$refs['accordion' + ind].scrollHeight + 'px'
          }
        }
      }
    },
    validateName() {
      clearTimeout(this.timeouts.name)
      this.timeouts.name = setTimeout(() => {
        this.errors.name = ''
        if (this.feedback.name.length === 0) {
          this.errors.name = this.$t('faq.name_required')
        } else if (this.feedback.name.length < 2 || this.feedback.name.length > 255) {
          this.errors.name = this.$t('faq.name_between')
        }
      }, this.timeoutTime)
    },
    validateEmail() {
      clearTimeout(this.timeouts.email)
      this.timeouts.email = setTimeout(() => {
        const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        this.errors.email = ''
        if (this.feedback.email.length === 0) {
          this.errors.email = this.$t('faq.email_required')
        } else if (!regexp.test(this.feedback.email)) {
          this.errors.email = this.$t('faq.email_not_valid')
        }
      }, this.timeoutTime)
    },
    validateMessage() {
      clearTimeout(this.timeouts.message)
      this.timeouts.message = setTimeout(() => {
        this.errors.message = ''
        if (this.feedback.message.length === 0) {
          this.errors.message = this.$t('faq.message_required')
        } else if (this.feedback.message.length < 2 || this.feedback.message.length > 1024) {
          this.errors.message = this.$t('faq.message_between')
        }
      }, this.timeoutTime)
    },
    validateNickname() {
      clearTimeout(this.timeouts.telegram)
      this.timeouts.telegram = setTimeout(() => {
        this.errors.telegram = ''
        if (this.feedback.telegram.length === 0) {
          this.errors.telegram = ''
        } else if (this.feedback.telegram.length < 2 || this.feedback.telegram.length > 1024) {
          this.errors.telegram = this.$t('faq.telegram_between')
        }
      }, this.timeoutTime)
    },
    clearForm() {
      this.feedback.name = ''
      this.feedback.email = ''
      this.feedback.message = ''
      this.feedback.telegram = ''
      this.errors.name = ''
      this.errors.email = ''
      this.errors.message = ''
      this.errors.telegram = ''
    },
    async sendFeedback() {
      this.feedbackLoading = true
      let noErrors = true
      for (const prop in this.errors) {
        if (this.errors[prop].length > 0) {
          noErrors = false
          break
        }
      }
      if (this.feedback.name.length === 0) {
        this.errors.name = this.$t('faq.name_required')
        noErrors = false
      }
      if (this.feedback.email.length === 0) {
        this.errors.email = this.$t('faq.email_required')
        noErrors = false
      }
      if (this.feedback.message.length === 0) {
        this.errors.message = this.$t('faq.message_required')
        noErrors = false
      }
      if (noErrors) {
        const request = await this.$generateApiRequest()
        request.post('feedback', this.feedback).then(() => {
          this.feedbackLoading = false
          this.clearForm()
          this.$nuxt.$emit('openSuccess', null, this.$t('faq.sent_success'))
        }).catch((err) => {
          this.feedbackLoading = false
          if (err.response.status !== 422) {
            this.$nuxt.$emit('openError', null, this.$t('faq.sent_error'))
          } else {
            this.$nuxt.$emit('openError', null, this.$t('faq.sent_typo'))
          }
          console.error(err)
        })
      } else {
        this.feedbackLoading = false
      }
    }
  }
}
</script>

<style scoped>
    @import url('../assets/css/new/faq.css');
</style>
